import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFuelTransactionsProcessingHold extends Layout {
    buttonRemoveHold: Button;
    sourceFuelDetailList: DataSource;
    tableFuelTransactions: Table;
}
